module.exports = {
  eventCategory: 'Editor UI | Tool Menu | text banners',

  clickEvent: function (event) {
    this.trackEvent({
      eventAction: 'add_click',
      eventLabel: this.svg['id']
    });
  },

  mouseUpEvent: function () {
    this.trackEvent({
      eventAction: 'add_drop',
      eventLabel: this.svg['id']
    });
  }
};
